import { IObservable, Subject } from '~/rage/utils';
import { LootBuyerType } from '~/shared';
import {
	ILootBuyersService,
	LootBuyersSellItem,
} from './lootBuyersServiceTypes';

export class LootBuyersServiceStub implements ILootBuyersService {
	private sellItems = new Subject<LootBuyersSellItem[]>([
		{
			id: 'amur_black',
			name: 'amur_black',
			price: 637,
			buyerType: LootBuyerType.FISH,
			itemId: 'amur_black',
		},
		{
			id: 'perch',
			name: 'perch',
			price: 1000,
			buyerType: LootBuyerType.FISH,
			itemId: 'perch',
		},
		{
			id: 'kutum',
			name: 'kutum',
			price: 919,
			buyerType: LootBuyerType.FISH,
			itemId: 'kutum',
		},
		{
			id: 'carp_mirror',
			name: 'carp_mirror',
			price: 646,
			buyerType: LootBuyerType.FISH,
			itemId: 'carp_mirror',
		},
		{
			id: 'rudd',
			name: 'rudd',
			price: 773,
			buyerType: LootBuyerType.FISH,
			itemId: 'rudd',
		},
		{
			id: 'bream',
			name: 'bream',
			price: 684,
			buyerType: LootBuyerType.FISH,
			itemId: 'bream',
		},
		{
			id: 'smelt',
			name: 'smelt',
			price: 541,
			buyerType: LootBuyerType.FISH,
			itemId: 'smelt',
		},
		{
			id: 'sturgeon_persian',
			name: 'sturgeon_persian',
			price: 700,
			buyerType: LootBuyerType.FISH,
			itemId: 'sturgeon_persian',
		},
		{
			id: 'shad_caspian',
			name: 'shad_caspian',
			price: 582,
			buyerType: LootBuyerType.FISH,
			itemId: 'shad_caspian',
		},
		{
			id: 'catfish',
			name: 'catfish',
			price: 631,
			buyerType: LootBuyerType.FISH,
			itemId: 'catfish',
		},
		{
			id: 'sturgeon_sterlet',
			name: 'sturgeon_sterlet',
			price: 690,
			buyerType: LootBuyerType.FISH,
			itemId: 'sturgeon_sterlet',
		},
		{
			id: 'pikeperch',
			name: 'pikeperch',
			price: 656,
			buyerType: LootBuyerType.FISH,
			itemId: 'pikeperch',
		},
		{
			id: 'roach',
			name: 'roach',
			price: 542,
			buyerType: LootBuyerType.FISH,
			itemId: 'roach',
		},
		{
			id: 'silver_carp_bighead',
			name: 'silver_carp_bighead',
			price: 623,
			buyerType: LootBuyerType.FISH,
			itemId: 'silver_carp_bighead',
		},
		{
			id: 'eel',
			name: 'eel',
			price: 609,
			buyerType: LootBuyerType.FISH,
			itemId: 'eel',
		},
	]);
	private ownedItems = new Subject<{ [itemId: string]: number }>({
		amur_black: 5,
		perch: 3,
		kutum: 2,
		carp_mirror: 4,
		rudd: 1,
	});
	private updatePriceTimestamp = new Subject(Date.now() + 2 * 60 * 1000);
	private currentLootBuyerType = new Subject<LootBuyerType | null>(
		LootBuyerType.FISH,
	);

	public getSellItems(): IObservable<LootBuyersSellItem[]> {
		return this.sellItems;
	}

	public getOwnedItems(): IObservable<{ [itemId: string]: number }> {
		return this.ownedItems;
	}

	public getUpdatePriceTimestamp(): IObservable<number> {
		return this.updatePriceTimestamp;
	}

	public getCurrentLootBuyerType(): IObservable<LootBuyerType | null> {
		return this.currentLootBuyerType;
	}

	public async sellItem(
		lootBuyerType: LootBuyerType,
		itemId: string,
	): Promise<void> {
		console.log('lootBuyers: sellItem', { lootBuyerType, itemId });
		const currentItems = { ...this.ownedItems.getValue() };
		delete currentItems[itemId];
		this.ownedItems.next(currentItems);
	}

	public async sellAllItems(lootBuyerType: LootBuyerType): Promise<void> {
		console.log('lootBuyers: sellAllItems', { lootBuyerType });
		this.ownedItems.next({});
	}

	public exitMenu(): void {
		console.log('lootBuyers: exitMenu');
	}
}
